import { render, staticRenderFns } from "./BasicsCardBox.vue?vue&type=template&id=1e05c7ba&scoped=true"
import script from "./BasicsCardBox.vue?vue&type=script&lang=js"
export * from "./BasicsCardBox.vue?vue&type=script&lang=js"
import style0 from "./BasicsCardBox.vue?vue&type=style&index=0&id=1e05c7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e05c7ba",
  null
  
)

export default component.exports